/**
 * Created by Andrey Popov on 25/2/20.
 */

const ServiceMessageView = cc.Node.extend({
    ctor: function (chatMessage) {
        this._super();

        this.chatMessage = chatMessage;

        this.setAnchorPoint(0, 0.5);

        const text = chatMessage.message.localize ? Messages.get(chatMessage.message.localize) : chatMessage.message;
        this.messageText = cleverapps.UI.generateOnlyText(text, cleverapps.styles.FONTS.SERVICE_MESSAGE_TEXT);
        this.messageText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        this.addChild(this.messageText);

        this.onResize();
    },

    onResize: function () {
        this.messageText.setDimensions(cleverapps.resolution.getSceneSize().width - cleverapps.styles.ServiceMessageView.padding, 0);
        this.setContentSize2(cleverapps.resolution.getSceneSize().width, this.messageText.height + cleverapps.styles.ServiceMessageView.padding);

        this.messageText.setAlignment(this.width / 2, this.height / 2);
    }
});

cleverapps.styles.ServiceMessageView = {
    padding: 50
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SERVICE_MESSAGE_TEXT: {
        size: 30,
        color: new cc.Color(83, 97, 106, 255),
        font: bundles.chat.urls.strict_font_ttf
    }
});